import pino from 'pino';

import {
  LogMsg,
  LogMsgKey,
} from './message';

type LoginUserInfoType = {
  id: string;
  role: string;
};

// ログ呼び出し時のランタイム情報
export type RuntimeInjectingLogType = {
  user: {
    auth: LoginUserInfoType | null;
    agent: string;
    location: {
      domain: string;
      url: string;
    };
  };
};

// ログのキー名から自動的に決まる部分
type LogMsgBasedType = {
  level: pino.Level;
  code: string;
  key: LogMsgKey;
  msg: string;
};

type LogDetailType = {
  info: unknown;
};

// ビルド情報
type BuildType = {
  mode: string;
};

/**
 * ログの構造を定義します。
 */
export type LogType = BuildType & LogDetailType & LogMsgBasedType & RuntimeInjectingLogType;

const createLogMsgBasedObject = (key: LogMsgKey): LogMsgBasedType => {
  const logMsgObj = LogMsg[key];
  const logLevel = logMsgObj.level;
  const formatLogMessage = `[ADMF-${logLevel[0].toUpperCase()}-${logMsgObj.code}] ${logMsgObj.msg}`;
  return {
    level: logMsgObj.level,
    code: logMsgObj.code,
    key,
    msg: formatLogMessage,
  };
};

export const createLogObject = (info: unknown, key: LogMsgKey, runtime: RuntimeInjectingLogType): LogType => ({
  ...createLogMsgBasedObject(key),
  ...runtime,
  info,
  mode: import.meta.env.MODE,
});

type GTMLogType = {
  event: pino.Level;
  log: BuildType & LogMsgBasedType & RuntimeInjectingLogType;
};
export const createGTMLogObject = (key: LogMsgKey, runtime: RuntimeInjectingLogType): GTMLogType => {
  const logObj = createLogMsgBasedObject(key);
  return {
    event: logObj.level,
    log: {
      ...logObj,
      ...runtime,
      mode: import.meta.env.MODE,
    },
  };
};
